function sendEventoGTM(formStep, formConversion) {
  if (window. tngaDataLayer) {
    window. tngaDataLayer.event = {
      "name": " formevent", 
      "componentName": "maintenance-calculator", 
      "componentGroup": "tools",
      "action": "form-step",
      "label":  formStep
    }
    window. tngaDataLayer.form = {
      "conversion": formConversion, 
      "name": "lead-maintenance-calculator", 
      "step": formStep
    }
    window.dataLayer.push({'event': 'formevent'});
  }
}

export default sendEventoGTM